import './Header.css';
import React, { useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { resetStep, setFromSummaryPage } from '../../store/reducers/flowStepReducer';

const Header = () => {
  const location = useLocation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log("Header11");

const planExistCustomer = useSelector(
  (state) => state.profileList?.planExistCustomer
);

  const isHomePage = location.pathname === '/';
  const isSummaryPage = location.pathname === '/summary';
  const raiseClaim = location.pathname === '/raise-claim';
  const trackClaim = location.pathname === '/track-claim';

  const handleBack = () => {
    if (isSummaryPage) {
      const storedData = localStorage.getItem('customerProfile');
      if (storedData) {
        localStorage.setItem('customerProfile', storedData);
      }
      dispatch(resetStep());
      dispatch(setFromSummaryPage(true));
      console.log("isSummaryPageisSummaryPage",isSummaryPage);
      navigate('/customer-profile');
    } else {
      switch (location.pathname) {
        case '/membership-features':
          navigate('/');
          break;
        case '/customer-profile':
          navigate('/');
          break;
        case '/payment-status':
          navigate('/');
          break;
        case '/my-plans':
          navigate('/');
          break;
        case '/raise-claim':
          navigate('/my-plans');
          break;
        case '/track-claim':
          navigate('/my-plans');
          break;
        default:
          navigate(-1);
      }
    }
  };

console.log("planExistCustomer",planExistCustomer);

  return (
    <header className="header-main">
      <div className="header-content">
        {!isHomePage && raiseClaim && (
          <div className="header-content-menu" onClick={handleBack}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/previous.svg`}
              alt="Back"
              className="header-image-menu"
            />
            <span>Raise a Claim</span>
          </div>
        )}
        {!isHomePage && !raiseClaim && trackClaim && (
          <div className="header-content-menu" onClick={handleBack}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/previous.svg`}
              alt="Back"
              className="header-image-menu"
            />
            <span>Track Claim</span>
          </div>
        )}
        {!isHomePage &&  !trackClaim && !raiseClaim && (
          <div className="header-content-menu" onClick={handleBack}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/previous.svg`}
              alt="Back"
              className="header-image-menu"
            />
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;